import { render, staticRenderFns } from "./AlarmEvent.vue?vue&type=template&id=6cd340f8&scoped=true"
import script from "./AlarmEvent.vue?vue&type=script&lang=js"
export * from "./AlarmEvent.vue?vue&type=script&lang=js"
import style0 from "./AlarmEvent.vue?vue&type=style&index=0&id=6cd340f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd340f8",
  null
  
)

export default component.exports